import { CLOSE_SURVEY_MODAL, OPEN_SURVEY_MODAL } from './types';

export const openSurveyModal = (isAutomated: boolean) => ({
  type: OPEN_SURVEY_MODAL,
  payload: {
    isAutomated,
  },
});
export const closeSurveyModal = () => ({ type: CLOSE_SURVEY_MODAL });
